<template>
    <div>
        <el-form :model="queryParams" ref="queryForm" :inline="true" style="overflow: hidden;" size="mini">
            <el-row :gutter="20" type="flex"
                style="display: inline;white-space:nowrap; font-size: calc(13vw * 100 / 1920); overflow-x: hidden;">
                <el-col :span="5">
                    <el-form-item label="海关名称" prop="hsName">
                        <el-input clearable v-model.trim="queryParams.hsName" style="width: 100%;"
                            placeholder="请输入海关名称"></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="5">
                    <el-form-item label="SAP品名" prop="erpName">
                        <el-input clearable v-model.trim="queryParams.erpName" placeholder="请输入ERP名称"></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="5">
                    <el-form-item label="SAP编码" prop="erpCode">
                        <el-input clearable v-model.trim="queryParams.erpCode" placeholder="请输入ERP编码"></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="5">
                    <el-form-item label="海关编码" prop="hsCode">
                        <el-input clearable v-model.trim="queryParams.hsCode" placeholder="请输入海关编码"></el-input>
                        <el-button type="primary" @click="submit" plain>查询</el-button>
                    </el-form-item>
                </el-col>
            </el-row>
        </el-form>
        <!-- <main> -->
            <vxe-toolbar style="padding: 5px 0;">
                <template style="display: flex;" v-slot:buttons>
                    <vxe-button icon="fa fa-plus" size="mini" style="background-color: #1890ff; color: #fff; margin-right: 1vw;"
                        @click="insertEvent()"> 新增</vxe-button>
                    <el-upload class="upload-demo" :action="url" :http-request="submitUpload" :file-list="fileList"
                        :before-upload="beforeUpload">
                        <vxe-button size="mini" style="background-color: #52c41a; color: #fff;">导入数据</vxe-button>
                    </el-upload>
                </template>
            </vxe-toolbar>
            <div style="display: block;  height: calc(100vh - 152px);"> 
                <vxe-table border style="font-size: calc(13vw * 100 / 1920); " row-key highlight-hover-row ref="xTable"
                    height="auto" resizable auto-resize :data="tableData"  header-align="center" align="left" width="100%" :row-config="{ isCurrent: true /* 启用当前行高亮 */  }"
                    @toggle-row-expand="toggleExpandChangeEvent" :expand-config="{ labelField: 'element' }" 
                    >
                    <vxe-table-column sortable type="seq" title="序号" width="3%" ></vxe-table-column>
                    <vxe-table-column sortable field="erpCode" title="SAP编码" width="8%" 
                        :cell-render="{ name: 'MyLink', events: { click: linkEvent } }">
                    </vxe-table-column>
                    <vxe-table-column sortable field="hsCode" title="海关编码" width="8%"></vxe-table-column>
                    <vxe-table-column sortable field="erpName" title="SAP品名" width="8%"></vxe-table-column>
                    <vxe-table-column sortable field="hsName" title="海关名称" width="20%"></vxe-table-column>
                    <!-- <vxe-table-column sortable field="unit" title="成交单位" width="6%"></vxe-table-column> -->
                    <vxe-table-column type="expand" field="element" title="申报要素" width="27%" >
                         <template #default="{ row }">
                            <vxe-button status="primary" mode="text" icon="vxe-icon-copy" @click="copyExpand(row.element)"></vxe-button>
                            <span> {{ row.element }} </span>
                         </template>
                    <!-- <vxe-table-column type="expand" field="element" title="申报要素" width="19%"> -->
                        <template v-slot:content="{ row, rowIndex }">
                            <el-descriptions direction="vertical" border size="mini" :column="expandData[rowIndex].length">
                                <el-descriptions-item v-for="item,index in expandData[rowIndex]" :key="index" :label="item.elementName" 
                                :label-class-name="item.elementRequired ?'my-label':''" :content-class-name="item.elementRequired ?'my-label':''">
                                    <span v-if="item.elementName === '品牌类型'">
                                        {{ brandType[item.elementValue].codeValue }}-{{ brandType[item.elementValue].codeName }} 
                                    </span>
                                     <span v-else-if="item.elementName === '出口享惠情况'">
                                        {{ exportBenefits[item.elementValue].codeValue }}-{{ exportBenefits[item.elementValue].codeName }} 
                                    </span>
                                    <span v-else>{{ item.elementValue }}</span>
                                </el-descriptions-item>
                            </el-descriptions>
                            <!-- <el-table ref="multipleTable" :data="getExpandData(rowIndex)" border stripe style="width: 100%" 
                            row-key="id" id="tableId" size="mini">
                                <el-table-column v-for="item in getExpandHeader(rowIndex)" :label="item.elementName"
                                    align="center" :prop="item.elementValue">
                                    <template slot-scope="scope">
                                        <div v-if="scope.row[item.elementValue] == null">数据加载中...</div>
                                        <div v-if="scope.row[item.elementValue] !== null">
                                            {{ scope.row[item.elementValue] }}</div>
                                    </template>
                                </el-table-column>
                            </el-table> -->
                        </template>
                    </vxe-table-column>
                    <vxe-table-column sortable field="createTime" title="更改时间" width="8.5%"></vxe-table-column>
                    <vxe-table-column sortable field="note" title="备注" width="18%"></vxe-table-column>
                </vxe-table>
            </div>
            <vxe-modal style="top: 10px;" v-model="showEdit" :title="selectRow ? '编辑&保存' : '新增&保存'" width="1500" min-width="1000"
                :loading="submitLoading" resize esc-closable @close="closeEvent()">
                <!-- <template v-slot> -->
                    <el-descriptions class="margin-top" :column="1" size="mini" border  >
                        <el-descriptions-item labelStyle="width:200px"> 
                            <template slot="label">
                                <span style="color: rgb(245, 108, 108);"> * </span>
                                海关编码
                            </template>
                            <el-input @keyup.enter.native="handleEnter" v-model.trim="detailData.hsCode" size="mini" class="yellow width_100"></el-input>
                        </el-descriptions-item>
                        <el-descriptions-item label="海关名称" labelStyle="width:200px"> 
                            <el-input disabled v-model.trim="detailData.hsName" size="mini"></el-input>
                        </el-descriptions-item>
                        <el-descriptions-item label="法定计量单位" labelStyle="width:200px"> 
                            <el-input disabled v-model.trim="detailData.hsUnit" size="mini"></el-input>
                        </el-descriptions-item>
                        <el-descriptions-item label="海关描述" labelStyle="width:200px"> 
                            <el-input disabled v-model.trim="detailData.hsDes" size="mini"></el-input>
                        </el-descriptions-item>
                        <el-descriptions-item labelStyle="width:200px"> 
                            <template slot="label">
                                <span style="color: rgb(245, 108, 108);"> * </span>
                                SAP编码
                            </template>
                            <el-input v-model.trim="addform.erpCode" size="mini" class="yellow width_100"></el-input>
                        </el-descriptions-item>
                        <el-descriptions-item labelStyle="width:200px"> 
                            <template slot="label">
                                <span style="color: rgb(245, 108, 108);"> * </span>
                                SAP品名
                            </template>
                            <el-input v-model.trim="addform.erpName" size="mini" class="yellow width_100"></el-input>
                        </el-descriptions-item>
                        <el-descriptions-item label="备注" labelStyle="width:200px"> 
                            <el-input v-model.trim="addform.note" size="mini" class="width_100"></el-input>
                        </el-descriptions-item>
                         <el-descriptions-item label=""> 
                            <span>规格型号（根据海关规定，以下要素应全部填报）。</span>
                        </el-descriptions-item>
                        <el-descriptions-item v-for="item,index in detailData.declarationElements" :key="index" :label="item.elementName">
                            <template slot="label">
                                <span v-if="item.elementRequired" style="color: rgb(245, 108, 108);"> * </span>
                                {{ item.elementName }}
                            </template>
                            <el-select size="mini" :class="item.elementRequired?'yellow width_100' : 'width_100'" v-if="item.elementName === '品牌类型'" filterable
                            :default-first-option="true" v-model="item.elementValue" placeholder="品牌类型" @change="(val) => handleBrandTypeChange(val, index)">
                                <el-option  v-for="item in brandType" :key="item.codeValue" :label="item.codeValue + ' - ' + item.codeName" :value="item.codeValue"> 
                                    <span class="margin_right_20">{{ item.codeValue }}</span>
                                    <span >{{ item.codeName }}</span> 
                                </el-option>
                            </el-select>
                            <el-select size="mini" :class="item.elementRequired?'yellow width_100' : 'width_100'" v-else-if="item.elementName === '出口享惠情况'" filterable
                            :default-first-option="true" v-model="item.elementValue" placeholder="出口享惠情况" @change="(val) => handleBrandTypeChange(val, index)">
                                <el-option  v-for="item in exportBenefits" :key="item.codeValue" :label="item.codeValue + ' - ' + item.codeName" :value="item.codeValue"> 
                                    <span class="margin_right_20">{{ item.codeValue }}</span>
                                    <span >{{ item.codeName }}</span> 
                                </el-option>
                            </el-select>
                            <!-- <el-input @input="linkElementValue" v-else-if="item.elementName === '签约日期'" v-model="item.elementValue" size="mini"
                            onkeyup="value=value.match(/\d{0,8}/,'')" :class="item.elementRequired?'yellow' : ''"></el-input> -->
                            <el-input @input="(val) => handleBrandTypeChange(val, index)" v-else v-model="item.elementValue" size="mini" :class="item.elementRequired?'yellow' : ''"></el-input>
                        </el-descriptions-item>
                        <el-descriptions-item label="规格型号"> 
                            <div class="flex_sb">
                                <span>
                                    {{ detailData.hsElements }} 
                                </span>
                                <span>
                                    (255字节)
                                </span>
                            </div>
                        </el-descriptions-item>
                    </el-descriptions>
                    <!-- <table class="table1" width="99.7%" border="1" cellspacing="0" cellpadding="0" align="center"
                        style="border-color: #b8b8b8;border:1px solid ;font-weight: bold; font-size: calc(13vw * 100 / 1920);">
                        <tr>
                            <td class="width2" style="width: 25%;"><span style="color: red;">*</span>海关编码</td>
                            <td class="yellow" colspan="3">
                                <input class="inputColor" @keyup.enter="handleEnter" v-model.trim="detailData.hsCode"
                                    type="text">
                            </td>
                        </tr>
                        <tr>
                            <td class="width2">海关名称</td>
                            <td class="grey" colspan="3">
                                <input disabled class="inputColor" v-model.trim="detailData.hsName" type="text">
                            </td>
                        </tr>
                        <tr>
                            <td class="width2">法定计量单位</td>
                            <td class="grey" colspan="3">
                                <input disabled class="inputColor" v-model.trim="detailData.hsUnit" type="text">
                            </td>
                        </tr>
                        <tr>
                            <td>海关描述</td>
                            <td class="grey" colspan="3"><input disabled v-model.trim="detailData.hsDes"
                                    class="inputColor" type="text"></td>
                        </tr>
                        <tr>
                            <td><span style="color: red;">*</span>SAP编码</td>
                            <td class="yellow" colspan="3"><input v-model.trim="addform.erpCode" class="inputColor"
                                    type="text"></td>
                        </tr>
                        <tr>
                            <td> <span style="color: red;">*</span>SAP品名</td>
                            <td class="yellow" colspan="3"><input v-model.trim="addform.erpName" class="inputColor"
                                    type="text"></td>
                        </tr>
                        <tr>
                            <td> <span style="color: red;">*</span>成交单位</td>
                            <td class="yellow" colspan="3">
                                <el-select filterable style="width: 100%;" v-model.trim="addform.unit"
                                    placeholder="请选择成交单位">
                                    <el-option class="selectColor" v-for="item in unity" :key="item.id"
                                        :label="item.unitName" :value="item.unitName">
                                        <span style="float: right; color: #8492a6; font-size: 13px">{{ item.id
                                            }}</span>
                                        <span style="float: left">{{ item.unitName }}</span>
                                    </el-option>
                                </el-select>
                            </td>
                        </tr>
                        <tr>
                            <td>备注</td>
                            <td class="yellow" colspan="3"><input v-model.trim="addform.note" class="inputColor"
                                    type="text"></td>
                        </tr>
                        <tr>
                            <td colspan="4">规格型号(根据海关规定，以下要素应全部填报)</td>
                        </tr>
                        <tr v-for="item,index  in detailData.declarationElements" :key="index">
                            <td><span v-if="item.elementRequired" style="color: red;">*</span>{{ item.elementName }}</td>
                            <td v-if="item.elementName === '品牌类型'">
                                <el-select size="mini" :class="item.elementRequired?'yellow width_100 inputColor' : 'width_100 inputColor'" v-model="item.elementValue" 
                                placeholder="品牌类型" @change="(val) => handleBrandTypeChange(val, index)">
                                    <el-option  v-for="items in brandType" :key="items.codeValue" :label="items.codeValue + ' - ' + items.codeName" :value="items.codeValue"> 
                                        <span class="margin_right_20">{{ items.codeValue }}</span>
                                        <span >{{ items.codeName }}</span> 
                                    </el-option>
                                </el-select>
                            </td>
                            <td v-else-if="item.elementName === '出口享惠情况'">
                                <el-select size="mini" :class="item.elementRequired?'yellow width_100 inputColor' : 'width_100 inputColor'"
                                 v-model="item.elementValue" placeholder="出口享惠情况" @change="pingjie">
                                    <el-option  v-for="items in exportBenefits" :key="items.codeValue" :label="items.codeValue + ' - ' + items.codeName" :value="items.codeValue"> 
                                        <span class="margin_right_20">{{ items.codeValue }}</span>
                                        <span >{{ items.codeName }}</span> 
                                    </el-option>
                                </el-select>
                            </td>
                            <td v-else colspan="3" class="yellow"><input v-model.trim="item.elementValue" @change="pingjie"
                                class="inputColor" type="text"></td>
                        </tr>
                        <tr>
                            <td>规格型号</td>
                            <td class="grey" colspan="3"><input v-model.trim="detailData.hsElements" disabled
                                    class="inputColor" type="text"><span>
                                    (255字节)
                                </span></td>
                        </tr>
                    </table> -->
                    <div style="text-align: center; margin-top: 0.5vh;">
                        <vxe-button status="primary" icon="fa fa-save" @click="saveAndEdit()">保存</vxe-button>
                        <vxe-button status="danger" icon="vxe-icon--refresh" @click="closeEvent()">重置</vxe-button>
                    </div>
                <!-- </template> -->
            </vxe-modal>
            <!-- 子组件预览表格弹框 -->
         <previewSon ref="previewSon" :excelList="preview" @previewSonClose="previewSonClose"></previewSon>
        <!-- </main>   -->
        <!-- <footer>
        </footer> -->
    </div>
</template>

<script>
import req from '@/utils/index.js';
import url from '@/config/url.js';
import previewSon from '../view/childrenconponents/previewTable.vue';
import VXETable from 'vxe-table';//渲染器必须导入
import AEObasicData from '@/config/AEObasicData.js'

export default {
    name: 'carControl',
    components: { previewSon, },
    data() {
        return {
            expandListHeader: [],//展开数组
            expandListBody: [],
            url: '',//文件上传地址
            queryParams: {
                hsName: '',  //创建人
                erpName: '',  //描述
                erpCode: '', //创建时间(开始)
                hsCode: '', //创建时间(结束)
            },
            tableData: [],
            detailData: {
                hsCode: '',
            },
            // detailData: [],
            showEdit: false,
            submitLoading: false,
            selectRow: null,
            addform: {
                unit: '',
                erpCode: '',
                erpName: '',
                firstUnit: '',
                secondtUnit: '',
                note: ''
            },
            saveEditData: {
                id: '',
                erpCode: '',
                hsCode: '',
                erpName: '',
                hsName: '',
                unit: '',
                element: '',
                note: ''
            },
            unity: [],//基础资料
            fileList: [],
            preview: [],//传值excel表格数据
            expandDataMap: [],
            // tableData1: [],
            // expandDataMap: {}, // 只保留一个定义
            expandHeaderMap: {},
            // loading: false, // 添加一个加载状态标志
            isEmpty: true,
            // 其他数据
            brandType: AEObasicData.BrandType, // 品牌类型
            exportBenefits:AEObasicData.ExportBenefits, // 出口享惠情况
            expandData:{}, // 点击下拉框显示的表格数据
        }
    },
    created() {
        if (this.tableData.length) {
            this.tableData = window.MOCK_DATA_LIST.slice(0, 20);
        }
        this.getUnit();
        // 创建一个简单的超链接渲染

    },
    watch: {
    },
    mounted() {
        // 注册自定义渲染器
        VXETable.renderer.add('MyLink', {
            renderDefault(h, renderOpts, params) {
                let { row, column } = params;
                let { events } = renderOpts;
                return [
                    <a class="my-link" onClick={() => events.click(params)}>{row[column.property]}</a>
                ];
            }
        });
    },
    methods: {
        linkEvent({ row }) {
            this.editEvent(row);
        },
        toggleExpandChangeEvent({ row, expanded }) {
            // this.loading = true;
            if (row && expanded === true) {
                this.$nextTick(() => {
                    const rowIndex = this.tableData.indexOf(row);
                    this.$set(this.expandData, rowIndex, []);  // 使用Vue.set确保响应式
                    // if (!this.expandDataMap[rowIndex]) {
                    //     this.expandDataMap[rowIndex] = [];
                    //     this.expandHeaderMap[rowIndex] = [];
                    // }
                    let URL = `${url.getElementByCode}?code=${row.hsCode}`;
                    req.get(URL).then(res => {
                        if (res.data.code === 200) {
                            let list = row.element;
                            const expandListHeader = res.data.data.element.split("$").map(item =>{
                                const elementName = item.split(":")[1]
                                const elementRequired = item.split(":")[2] === '1' ? true : false
                                return {elementName:elementName,elementValue:"",elementRequired:elementRequired}
                            });
                            const elementsArray = list.split('|');
                            const newExpandListHeader = expandListHeader.map((element, index) => {
                                if (elementsArray[index]) {
                                    element.elementValue = elementsArray[index]
                                    // element.elementValue = `id${index}`;
                                } else {
                                    element.elementValue = '';
                                }
                                return element;
                            });
                            // const newArr = elementsArray.map((value, index) => ({ [`id${index}`]: value }));
                            // const mergedObject = newArr.reduce((acc, obj) => ({ ...acc, ...obj }), {});
                            // // 检查数据是否已存在，不存在才添加
                            // if (!this.expandDataMap[rowIndex].some(item => JSON.stringify(item) === JSON.stringify(mergedObject))) {
                            //     this.expandDataMap[rowIndex].push(mergedObject);
                            // }
                            this.$set(this.expandData, rowIndex, newExpandListHeader)
                            // this.expandHeaderMap[rowIndex] = newExpandListHeader;
                            // this.loading = false;
                        } else {
                            this.$message({
                                type: 'error',
                                message: res.data.message
                            });
                        }
                    });
                });
            }
        },
        // toggleExpandChangeEvent({ row, expanded }) {
        //     if (row && expanded === true) {
        //         this.$nextTick(() => {
        //             const rowIndex = this.tableData.indexOf(row);
        //             if (!this.expandDataMap[rowIndex]) {
        //                 this.expandDataMap[rowIndex] = [];
        //                 this.expandHeaderMap[rowIndex] = [];
        //             }
        //             let URL = `${url.getElementByCode}?code=${row.hsCode}`;
        //             req.get(URL).then(res => {
        //                 if (res.data.code === 200) {
        //                     let list = row.element;
        //                     const expandListHeader = res.data.data.declarationElements;
        //                     const elementsArray = list.split('|');
        //                     const newExpandListHeader = expandListHeader.map((element, index) => {
        //                         if (elementsArray[index]) {
        //                             element.elementValue = `id${index}`;
        //                         } else {
        //                             element.elementValue = '';
        //                         }
        //                         return element;
        //                     });
        //                     const newArr = elementsArray.map((value, index) => ({ [`id${index}`]: value }));
        //                     const mergedObject = newArr.reduce((acc, obj) => ({ ...acc, ...obj }), {});
        //                     this.expandDataMap[rowIndex].push(mergedObject);
        //                     this.expandHeaderMap[rowIndex] = newExpandListHeader;
        //                     this.$message({
        //                         type: 'success',
        //                         message: res.data.message
        //                     });
        //                 } else {
        //                     this.$message({
        //                         type: 'error',
        //                         message: res.data.message
        //                     });
        //                 }
        //             });
        //         });
        //     }
        // },
        // getExpandData(rowIndex) {
        //     return this.expandDataMap[rowIndex] || [];
        // },
        // getExpandHeader(rowIndex) {
        //     return this.expandHeaderMap[rowIndex] || [];
        // },
        //获取详细要素表
        getDetail(tempValue) {
            let URL = `${url.getElementByCode}?code=${this.detailData.hsCode}`;
            req.get(URL).then(res => {
                if (res.data.code === 200) {
                    this.detailData = res.data.data;
                    // this.detailData.declarationElements.splice(-3);
                    this.detailData.declarationElements = res.data.data.element.split("$").map(item =>{
                            const elementName = item.split(":")[1]
                            const elementRequired = item.split(":")[2] === '1' ? true : false
                            return {elementName:elementName,elementValue:"",elementRequired:elementRequired}
                    })
                    // this.$message({
                    //     type: 'success',
                    //     message: res.data.message
                    // });
                    if (tempValue) {
                        this.detailData.hsElements = tempValue.element;
                        const elementsArray = this.detailData.hsElements.split('|');
                        this.detailData.declarationElements.forEach((element, index) => {
                            if (elementsArray[index]) {
                                element.elementValue = elementsArray[index];
                            } else {
                                element.elementValue = '';
                            }
                        });
                    }

                } else {
                    this.$message({
                        type: 'error',
                        message: res.data.message
                    });
                }
            })
        },
        // 关闭上传预览
        previewSonClose(){
            this.$refs.previewSon.previewData = false;
            this.fileList = []
        },
        // 上传成功
        uploadSuccess() {
            // this.$refs.addFund.dialogFormVisible = true;
            this.$refs.previewSon.previewData = true;
            this.$nextTick(() => {
                this.$refs.previewSon.getData();
            });
        },
        submitUpload(item) {
            let fd = new FormData()
            fd.append('file', item.file)
            let URL = `${url.readFile}/`
            req.post(URL, fd).then(res => {
                if (res.data.code === 200) {
                    this.preview = res.data.data;
                    // this.$message({
                    //     type: 'success',
                    //     message: res.data.message
                    // })
                    this.uploadSuccess();
                } else {
                    this.$message({
                        type: 'error',
                        message: res.data.message
                    })
                }
            })
            this.fileList = []
        
        },
        beforeUpload(file) {
            var FileExt = file.name.replace(/.+\./, "");
            const whiteList = ["xlsx"];
            const isLt5M = file.size / 1024 / 1024 < 50;
            var extension = ['exe', 'iso'].indexOf(FileExt.toLowerCase()) === -1;
            if (whiteList.indexOf(FileExt.toLowerCase()) === -1) {
                this.$message({
                    type: 'error',
                    message: '上传文件只能是xlsx格式！'
                })
                return false;
            }
            if (!isLt5M) {
                this.$message({
                    type: 'warning',
                    message: '附件大小超限，文件不能超过 50M'
                })
                return false
            }
        },
        saveAndEdit() {
            if (this.detailData.declarationElements) {
                for(let item  of this.detailData.declarationElements){
                    if(item.elementRequired){
                        if(item.elementValue == ''){
                            this.$message({
                                message: '请填写必填项',
                                type: 'warning'
                            });
                            return false
                        }
                    }
                }
                // for (let item of this.detailData.declarationElements) {
                //     if (!item.elementValue) {
                //         this.isEmpty = false;
                //         break;
                //     } else {
                //         this.isEmpty = true;
                //     }
                // }
            }
            if (this.detailData.hsCode && this.addform.erpCode && this.addform.erpName) {
            // if (this.isEmpty && this.detailData.hsCode && this.addform.erpCode && this.addform.erpName && this.addform.unit) {
                const tempValue = JSON.parse(JSON.stringify(this.detailData));
                const tempObj = JSON.parse(JSON.stringify(this.addform));
                this.saveEditData.hsCode = tempValue.hsCode;
                this.saveEditData.erpCode = tempObj.erpCode;
                this.saveEditData.erpName = tempObj.erpName;
                this.saveEditData.hsName = tempValue.hsName;
                this.saveEditData.unit = tempObj.unit;
                this.saveEditData.element = tempValue.hsElements;
                this.saveEditData.note = tempObj.note;
                let URL = `${url.modify}`
                req.post(URL, this.saveEditData).then(res => {
                    if (res.data.code === 200) {
                        this.$message({
                            type: 'success',
                            message: res.data.data
                        });
                        this.showEdit = false;
                        this.getData();
                    } else {
                        this.$message({
                            type: 'info',
                            message: res.data.message
                        });
                    }
                })
            } else {
                this.$message({
                    type: 'error',
                    message: '黄色的必填项不能为空！'
                });
            }


        },
        // 编辑修改
        async editEvent(row) {
            // 获取数据
            this.showEdit = true;
            const tempValue = JSON.parse(JSON.stringify(row));
            this.detailData.hsCode = tempValue.hsCode;
            this.addform.erpName = tempValue.erpName;
            this.addform.erpCode = tempValue.erpCode;
            this.addform.unit = tempValue.unit;
            this.addform.note = tempValue.note;
            this.saveEditData.id = tempValue.id;

            await new Promise((resolve) => {
                // 这里不需要做任何事情，只是为了确保代码暂停，直到所有同步操作完成
                resolve();
            });
            this.getDetail(tempValue);
        },
        // 关闭销毁
        closeEvent() {
            this.detailData.hsCode = '';
            this.detailData.hsName = '';
            this.detailData.hsUnit = '';
            this.detailData.hsDes = '';
            this.detailData.hsElements = '';
            this.detailData.declarationElements = [];
            this.addform.unit = '';
            this.addform.erpCode = '';
            this.addform.erpName = '';
            this.addform.note = '';
            this.addform.firstUnit = '';
            this.addform.secondtUnit = '';
            this.saveEditData.id = '';

        },
        //回车
        handleEnter() {
            this.getDetail();
        },
        pingjie() {
            // 动态表单的值拼接起来
            let hsElement = this.detailData.declarationElements.map(element => {
                return element.elementValue + (element.elementValue !== "" ? "|" : "");
            }).join("");
            //删除最后一个/
            this.detailData.hsElements = hsElement.replace(/\|$/, '');

        },
        handleBrandTypeChange(value, index) {
            // 确保响应式更新
            this.$set(this.detailData.declarationElements[index], 'elementValue', value);
            this.$nextTick(() => {
                this.$forceUpdate(); // 确保在 DOM 更新周期后强制刷新
            });
            // 其他处理逻辑
            this.pingjie();
        },
        insertEvent() {
            this.showEdit = true;
            this.selectRow = null
        },
        submit() {
            this.getData();
        },

        // 获取数据列表
        getData(page) {
            let URL = `${url.getListBy}`
            req.post(URL, this.queryParams).then(res => {
                if (res.data.code === 200) {
                    this.tableData = res.data.data;
                }
            })
        },
        //基础资料成交单位
        getUnit() {
            let URL = `${url.getUnitByName}?name=`
            req.get(URL).then(res => {
                if (res.data.code === 200) {
                    this.unity = res.data.data;
                }
            })
        },
        // 双击复制
        async copyExpand(element){
            this.$copyText(element).then( (e) => {
                this.$message({
                    type: 'success',
                    message: '复制成功'
                });
            } )
            .catch( (e) => {
                this.$message({
                    type: 'error',
                    message: '复制失败'
                });
            } )
        }
    },
}
</script>

<style lang="css" scoped>
::v-deep .vxe-header--row {
    background-color: #a6e3e9;
    
    /* color: #fff; */
}

::v-deep .el-table,
::v-deep .el-table__expanded-cell {
    background-color: #ffc53d !important;
}

::v-deep .vxe-body--row {
    /* background-color: #c8ffff !important; */
    /* background-color: #275ecc; */

}
::v-deep .vxe-header--column{
    padding: 2px 0px !important;
}
/* 表格内背景颜色 */
::v-deep .el-table th,
::v-deep .el-table tr,
::v-deep .el-table td {
    background-color: #ffc53d !important;
    border: 1px solid rgb(145, 133, 98);
    color: rgb(62, 73, 73);
    font-weight: bold;
}

::v-deep .vxe-toolbar .vxe-button--wrapper {
    display: flex !important;
}

.custom-form-item .el-form-item__label {
    display: inline-block;
    vertical-align: middle;
}

.el-form-item {
    margin-bottom: 0;
}

::v-deep .vxe-table .vxe-body--column:not(.col--ellipsis),
.vxe-table .vxe-footer--column:not(.col--ellipsis),
.vxe-table .vxe-header--column:not(.col--ellipsis) {
    padding: 0;
}

::v-deep .el-table .warning-row {
    background: oldlace;
}

::v-deep .el-table .success-row {
    background: #f0f9eb;
}

::v-deep .el-pagination {
    padding: 0;
}

::v-deep .description-column .cell {
    white-space: normal;
    word-wrap: break-word;
    /* background-color: aqua; */
}

.inputColor {
    BACKGROUND-COLOR: transparent;
    border: none;
    width: 100%;
}

.el-input__inner {
    color: black;
    border-color: none;
    border-radius: 0%;
    background-color: transparent;
    font-size: calc(15vw * 100 / 1920);
    height: 100%;
    padding: 0;

}

.grey {
    background-color: #ebebeb;
}

.yellow {
    background-color: #fafec1;
}
/* 输入框黄色 */
::v-deep .yellow .el-input__inner {
    background-color: #FAFFBD;
}
.white {
    background-color: #fff;
}

/* 聚焦时的样式 */
/* .el-select .el-input.is-focus .el-input__inner {
    border-color: none;
    background-color: transparent;
} */

.table1 td {
    height: 8px;
}


/* ::v-deep .el-select .el-input__inner {
    padding: 0;
    height: 2vh;
    line-height: 2vh;
    background-color: #fafec1;
    border: 0;
} */

.vxe-toolbar {
    height: auto;
}

.upload-demo {
    display: flex;
}

/* ::v-deep .el-upload-list__item{
    margin-top: 5;
} */
.el-upload-list__item:first-child {
    margin-top: 0 !important;
}

::v-deep .el-upload-list__item {
    margin-top: 0 !important;
}

/* ::v-deep .el-upload-list__item{
    margin-top: 5;
} */

/* .el-upload-list__item {
    line-height: 0;
} */
::v-deep .el-upload-list {
    display: flex;
    align-items: center;
}

::v-deep .el-upload-list__item-name {
    margin-right: 0.9vw;
}

.hoverStyle:hover {
    color: blue;
    /* 设置悬停时的字体颜色 */
    text-decoration: underline;
    /* 添加下划线 */
}

::v-deep .my-link {
    color: blue;
    /* 超链接颜色 */
    text-decoration: underline;
    /* 下划线 */
    cursor: pointer;
    /* 鼠标指针 */
}

::v-deep .el-table .el-table__cell {
    padding: 0px 0;
}

::v-deep .cell {
    /* white-space: nowrap; */
    /* overflow: auto; */
    display: inline-block;
}

::v-deep .el-table .cell {
    padding: 0;
}

::v-deep .vxe-table .vxe-body--expanded-cell {
    padding: 0px;
    margin-top: -1.7vh;
}

.vxe-table {
    color: black;
}
.width_100{
    width: 100%;
    /* border: black 1px solid; */
}
.margin_right_20{
    margin-right: 20px;
}
::v-deep .el-descriptions--mini.is-bordered .el-descriptions-item__cell{
    padding: 2px 10px;
}
::v-deep .vxe-modal--box{
    top: 50px !important;
}

/* ::v-deep .vxe-table .vxe-cell{
    border: 1px solid rgb(112, 109, 109);
} */
/* ::v-deep .vxe-body--column {
      border-left: 1px solid #868383 !important;
      border-bottom: 1px solid #868383 !important;
}
::v-deep th.vxe-header--column{
      border-left: 1px solid #868383 !important;
      border-bottom: 2px solid #868383 !important;
 
  } */
/* ::v-deep .vxe-body--expanded-row {
    background-color: #dbe2ef;
    /* background-color: transparent; */
/* }
  ::v-deep .vxe-body--expanded-column{
    background-color: #dbe2ef;
  }  */

/* .el-table__header-wrapper{
   
 } */
</style>
<style>
.my-label {
    background: #FAFFBD !important;
}
.vxe-table--render-default .vxe-body--row.row--current {
    /* background-color: rgba(128, 255, 117, 0.5) !important; */
}
</style>